module.exports = __webpack_public_path__ + "img/关于我们Mobile.9781683d.jpg";